export default __webpack_public_path__ + "static/media/ct-03.9b281b38.jpeg";